import { render, staticRenderFns } from "./InformesGeneradosPantalla.vue?vue&type=template&id=421941ea&scoped=true&"
import script from "./InformesGeneradosPantalla.vue?vue&type=script&lang=ts&"
export * from "./InformesGeneradosPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./InformesGeneradosPantalla.vue?vue&type=style&index=0&id=421941ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421941ea",
  null
  
)

export default component.exports